# GraphQL fragment to remvoe an integration

#import "../../../calendar/graphql/fragments/calendar-sync.graphql"
#import "../../../tasks/graphql/fragments/task-sync.graphql"

mutation clearIntegrationOfType($externalService: ExternalService!) {
    clearIntegration(input: {externalService: $externalService}) {
        userEmail {
            display
        }
        calendarSync {
            ...CalendarSync
        }
        taskSync {
            ...TaskSync
        }
    }
}
